if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaContainer = this.querySelector('[role="document"]');
        this.dragState = null;
        this.suppressZoomClick = false;

        this.mediaContainer?.addEventListener('click', (event) => {
          const image = event.target.closest('img[data-media-id]');
          if (!image) return;

          if (this.suppressZoomClick) {
            this.suppressZoomClick = false;
            return;
          }

          this.toggleImageZoom(image);
        });

        this.mediaContainer?.addEventListener('pointerdown', (event) => {
          const image = event.target.closest('img.is-zoomed');
          if (!image || event.pointerType !== 'mouse') return;

          this.dragState = {
            pointerId: event.pointerId,
            startX: event.clientX,
            startY: event.clientY,
            scrollLeft: this.mediaContainer.scrollLeft,
            scrollTop: this.mediaContainer.scrollTop,
            moved: false,
          };
          image.setPointerCapture(event.pointerId);
          image.classList.add('is-dragging');
        });

        this.mediaContainer?.addEventListener('pointermove', (event) => {
          if (!this.dragState || this.dragState.pointerId !== event.pointerId) return;

          const deltaX = event.clientX - this.dragState.startX;
          const deltaY = event.clientY - this.dragState.startY;
          if (Math.abs(deltaX) + Math.abs(deltaY) > 4) this.dragState.moved = true;

          this.mediaContainer.scrollLeft = this.dragState.scrollLeft - deltaX;
          this.mediaContainer.scrollTop = this.dragState.scrollTop - deltaY;
        });

        const endDrag = (event) => {
          if (!this.dragState || this.dragState.pointerId !== event.pointerId) return;
          this.suppressZoomClick = this.dragState.moved;
          event.target.classList.remove('is-dragging');
          this.dragState = null;
        };

        this.mediaContainer?.addEventListener('pointerup', endDrag);
        this.mediaContainer?.addEventListener('pointercancel', endDrag);
      }

      hide() {
        this.resetImageZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.resetImageZoom();
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        container.scrollTop = activeMedia.offsetTop;
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      toggleImageZoom(image) {
        const shouldZoom = !image.classList.contains('is-zoomed');
        this.resetImageZoom();
        if (!shouldZoom) return;

        image.classList.add('is-zoomed');
        this.mediaContainer.classList.add('is-zoomed');

        requestAnimationFrame(() => {
          this.mediaContainer.scrollLeft = (image.scrollWidth - this.mediaContainer.clientWidth) / 2;
          this.mediaContainer.scrollTop = (image.scrollHeight - this.mediaContainer.clientHeight) / 2;
        });
      }

      resetImageZoom() {
        this.querySelectorAll('img.is-zoomed, img.is-dragging').forEach((image) => {
          image.classList.remove('is-zoomed', 'is-dragging');
        });
        this.mediaContainer?.classList.remove('is-zoomed');
        this.dragState = null;
        this.suppressZoomClick = false;
      }
    }
  );
}
